module.exports = __webpack_public_path__ + "img/default-img.124bc1a0.png";